/* Oreganix theme JS — navigation, gallery, variants, quantity, tabs, FAQ, AJAX cart drawer */

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

/* ── Mobile nav ── */
function initNav() {
  const toggle = document.querySelector('.menu-toggle');
  const nav = document.getElementById('site-nav');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', () => {
    const open = nav.classList.toggle('open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
}

/* ── Product gallery ── */
function initGallery() {
  const mainImg = document.getElementById('main-product-img');
  const thumbs = document.querySelectorAll('.product-thumb');
  if (!mainImg || !thumbs.length) return;
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      thumbs.forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
      mainImg.src = thumb.dataset.src;
      mainImg.alt = thumb.dataset.alt || mainImg.alt;
    });
  });
}

/* ── Variant selection ── */
function getVariantData() {
  const el = document.getElementById('product-variant-data');
  if (!el) return [];
  try { return JSON.parse(el.textContent); } catch { return []; }
}

function initVariants() {
  const select = document.getElementById('product-variant-select');
  if (!select) return;
  const variants = getVariantData();
  const buttons = document.querySelectorAll('.variant-btn');

  function selectedOptions() {
    const opts = [];
    document.querySelectorAll('.variant-group').forEach((group) => {
      const sel = group.querySelector('.variant-btn.selected');
      if (sel) opts.push(sel.dataset.value);
    });
    return opts;
  }

  function syncVariant() {
    const opts = selectedOptions();
    const match = variants.find((v) =>
      opts.every((val, i) => v[`option${i + 1}`] === val)
    );
    if (!match) return;
    select.value = match.id;
    updatePriceDisplays(match);
  }

  function updatePriceDisplays(variant) {
    if (hasKachingBundles()) {
      syncKachingBundlePrices();
    } else {
      const cents = variantPriceCents(variant);
      if (cents == null) return;
      updateLivePriceDisplays(
        formatMoney(cents),
        variant.compare_at_price && variant.compare_at_price > variant.price
          ? formatMoney(Math.round(Number(variant.compare_at_price)))
          : null
      );
    }
    const atc = document.getElementById('purchase');
    if (atc) {
      atc.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      atc.disabled = !variant.available;
    }
  }

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.variant-group');
      group.querySelectorAll('.variant-btn').forEach((b) => b.classList.remove('selected'));
      btn.classList.add('selected');
      syncVariant();
    });
  });

  syncVariant();
}

/* ── Quantity stepper ── */
function initQty() {
  document.querySelectorAll('.qty-stepper').forEach((stepper) => {
    const input = stepper.querySelector('input');
    stepper.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    stepper.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });
}

/* ── Tabs ── */
function initTabs() {
  document.querySelectorAll('.product-tabs').forEach((tabs) => {
    tabs.querySelectorAll('.tab-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        tabs.querySelectorAll('.tab-btn').forEach((b) => b.classList.remove('active'));
        tabs.querySelectorAll('.tab-panel').forEach((p) => p.classList.remove('active'));
        btn.classList.add('active');
        tabs.querySelector(`[data-panel="${btn.dataset.tab}"]`)?.classList.add('active');
      });
    });
  });
}

/* ── FAQ accordions ── */
function initFaq() {
  document.querySelectorAll('.faq-q').forEach((q) => {
    q.addEventListener('click', () => {
      q.closest('.faq-item').classList.toggle('open');
    });
  });
}

/* ── Mobile sticky CTA ── */
function initStickyCta() {
  const sticky = document.querySelector('.mobile-sticky-cta');
  const atc = document.getElementById('purchase');
  if (!sticky || !atc) return;
  const observer = new IntersectionObserver(
    ([entry]) => sticky.classList.toggle('visible', !entry.isIntersecting),
    { threshold: 0 }
  );
  observer.observe(atc);
  sticky.querySelector('[data-sticky-atc]')?.addEventListener('click', () => {
    atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
}

/* ── AJAX cart drawer ── */
const CartDrawer = {
  el: null,

  init() {
    this.el = document.getElementById('cart-drawer');
    if (!this.el) return;

    document.querySelectorAll('[data-cart-open]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });
    this.el.querySelectorAll('[data-cart-close]').forEach((btn) => {
      btn.addEventListener('click', () => this.close());
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });

    this.refresh();
  },

  open() {
    this.el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  },

  close() {
    this.el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  },

  async refresh() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      this.render(cart);
    } catch { /* leave server-rendered state */ }
  },

  async changeLine(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    const cart = await res.json();
    this.render(cart);
  },

  render(cart) {
    const count = document.getElementById('cart-drawer-count');
    const items = document.getElementById('cart-drawer-items');
    const empty = document.getElementById('cart-drawer-empty');
    const footer = document.getElementById('cart-drawer-footer');
    const subtotal = document.getElementById('cart-drawer-subtotal');

    document.querySelectorAll('.header-cart-count').forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });

    if (count) count.textContent = `(${cart.item_count})`;
    if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price);
    if (empty) empty.hidden = cart.item_count > 0;
    if (footer) footer.hidden = cart.item_count === 0;

    if (!items) return;
    items.innerHTML = cart.items.map((item, i) => `
      <div class="cart-drawer-item">
        <img src="${item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') : ''}" alt="" width="62" height="62" loading="lazy">
        <div>
          <div class="cart-drawer-item-title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer-item-meta">${item.variant_title}</div>` : ''}
          ${item.selling_plan_allocation ? `<div class="cart-drawer-item-meta">↻ ${item.selling_plan_allocation.selling_plan.name}</div>` : ''}
          <div class="cart-drawer-item-qty">
            <button type="button" data-drawer-minus="${i + 1}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-drawer-plus="${i + 1}" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <div>
          <div class="cart-drawer-item-price">${formatMoney(item.final_line_price)}</div>
          <button type="button" class="cart-drawer-item-remove" data-drawer-remove="${i + 1}">Remove</button>
        </div>
      </div>
    `).join('');

    items.querySelectorAll('[data-drawer-minus]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const line = parseInt(btn.dataset.drawerMinus, 10);
        const qty = cart.items[line - 1].quantity - 1;
        this.changeLine(line, qty);
      });
    });
    items.querySelectorAll('[data-drawer-plus]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const line = parseInt(btn.dataset.drawerPlus, 10);
        this.changeLine(line, cart.items[line - 1].quantity + 1);
      });
    });
    items.querySelectorAll('[data-drawer-remove]').forEach((btn) => {
      btn.addEventListener('click', () => {
        this.changeLine(parseInt(btn.dataset.drawerRemove, 10), 0);
      });
    });
  },
};

/* ── Kaching bundle price sync (read live prices from Kaching UI + Shopify variant) ── */
function hasKachingBundles() {
  return Boolean(
    document.querySelector('script.kaching-bundles-deal-block-settings')
    || document.querySelector('.kaching-bundles__bar')
  );
}

function getSelectedKachingBar(form) {
  const scope = form || document;
  return scope.querySelector('.kaching-bundles__bar--selected')
    || scope.querySelector('.kaching-bundles__bar input[type="radio"]:checked')?.closest('.kaching-bundles__bar')
    || document.querySelector('.kaching-bundles__bar--selected')
    || document.querySelector('.kaching-bundles__bar input[type="radio"]:checked')?.closest('.kaching-bundles__bar');
}

function readKachingBarPrices(bar) {
  if (!bar) return null;
  const priceText = bar.querySelector('.kaching-bundles__bar-price')?.textContent?.trim();
  if (!priceText) return null;
  const compareText = bar.querySelector('.kaching-bundles__bar-full-price')?.textContent?.trim();
  return {
    price: priceText,
    compare: compareText && compareText !== priceText ? compareText : null,
  };
}

function getSelectedVariant() {
  const variants = getVariantData();
  if (!variants.length) return null;
  const form = document.getElementById('product-form');
  const select = form?.querySelector('#product-variant-select, select[name="id"]');
  return variants.find((v) => select && String(v.id) === String(select.value)) || variants[0];
}

function variantPriceCents(variant) {
  if (!variant?.price && variant?.price !== 0) return null;
  const raw = Number(variant.price);
  if (!Number.isFinite(raw)) return null;
  // Shopify variant JSON uses cents; product.js uses cents too.
  return Math.round(raw);
}

function updateLivePriceDisplays(priceText, compareText) {
  document.querySelectorAll('[data-live-price]').forEach((el) => {
    el.textContent = priceText;
  });
  document.querySelectorAll('[data-live-compare]').forEach((el) => {
    if (compareText) {
      el.textContent = compareText;
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  });
}

function syncKachingBundlePrices() {
  const form = document.getElementById('product-form');
  const barPrices = readKachingBarPrices(getSelectedKachingBar(form));
  if (barPrices) {
    updateLivePriceDisplays(barPrices.price, barPrices.compare);
    return true;
  }

  const variant = getSelectedVariant();
  const cents = variantPriceCents(variant);
  if (cents == null) return false;

  const compareCents = variant?.compare_at_price ? Math.round(Number(variant.compare_at_price)) : null;
  updateLivePriceDisplays(
    formatMoney(cents),
    compareCents && compareCents > cents ? formatMoney(compareCents) : null
  );
  return true;
}

function initKachingBundlePriceSync() {
  const form = document.getElementById('product-form');
  if (!form || !hasKachingBundles()) return;

  let timer = null;
  const scheduleSync = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      syncKachingBundlePrices();
      // Kaching repaints bar prices asynchronously after bundle/subscription clicks.
      setTimeout(syncKachingBundlePrices, 120);
      setTimeout(syncKachingBundlePrices, 350);
    }, 0);
  };

  scheduleSync();

  const observeTarget = form.querySelector('.kaching-bundles') || form;
  new MutationObserver(scheduleSync).observe(observeTarget, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
    characterData: true,
  });

  form.addEventListener('change', scheduleSync, true);
  form.addEventListener('input', scheduleSync, true);
  form.addEventListener('click', (event) => {
    if (event.target.closest('.kaching-bundles__bar, .kaching-bundles__bar-main, [class*="kaching-subscriptions"], [class*="sealsubs"], [name^="subs_type_"]')) {
      scheduleSync();
    }
  }, true);
}

/* ── Cart page remove buttons ── */
function initCartPage() {
  document.querySelectorAll('.cart-remove-btn').forEach((btn) => {
    btn.addEventListener('click', async () => {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(btn.dataset.line, 10), quantity: 0 }),
      });
      window.location.reload();
    });
  });
}

/* ── Track order form ── */
function initTrackOrderForm() {
  const form = document.getElementById('track-order-form');
  if (!form) return;

  form.addEventListener('submit', () => {
    const orderInput = form.querySelector('[name="order_number"]');
    if (!orderInput?.value) return;
    orderInput.value = orderInput.value.replace(/^#/, '').trim();
  });
}

/* ── Cinnamon LP: scroll CTAs + carousel ── */
function initCinnamonLanding() {
  document.querySelectorAll('.cinnamon-scroll-cta').forEach((link) => {
    link.addEventListener('click', (e) => {
      const target = document.getElementById('purchase') || document.querySelector('.product-info-sticky') || document.querySelector('#product-form');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  document.querySelectorAll('[data-cinnamon-carousel]').forEach((root) => {
    const track = root.querySelector('.cinnamon-reasons-track');
    const cards = track ? [...track.children] : [];
    if (cards.length <= 1) return;

    let index = 0;
    const update = () => {
      track.style.transform = `translateX(-${index * 100}%)`;
    };

    root.querySelector('.cinnamon-carousel-prev')?.addEventListener('click', () => {
      index = (index - 1 + cards.length) % cards.length;
      update();
    });
    root.querySelector('.cinnamon-carousel-next')?.addEventListener('click', () => {
      index = (index + 1) % cards.length;
      update();
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initNav();
  initGallery();
  initVariants();
  initQty();
  initTabs();
  initFaq();
  initStickyCta();
  initKachingBundlePriceSync();
  initTrackOrderForm();
  initCinnamonLanding();
  initCartPage();
  CartDrawer.init();
});
